import React, { ReactNode, useCallback, useMemo, useState } from 'react';

import { Box, Button, ButtonProps } from '@mui/material';
import { ModalDialog } from '@provider-portal/common/components/ModalDialog/ModalDialog';

interface ConfirmButtonProps {
  strings: {
    buttonText: ReactNode;
    backText: ReactNode;
    title: ReactNode;
    text: ReactNode;
    cancelText: ReactNode;
    confirmText: ReactNode;
  };
  variant?: ButtonProps['variant'];
  color: ButtonProps['color'];
  onConfirm: () => void;
  onBack: () => void;
}

export const ConfirmButton = (props: ConfirmButtonProps) => {
  const { strings, variant = 'contained', color = 'primary', onConfirm, onBack } = props;

  const [isOpen, setIsOpen] = useState(false);

  const handleClickOpen = useCallback(() => setIsOpen(true), []);
  const handleClickBack = useCallback(() => onBack(), [onBack]);
  const handleClose = useCallback(() => setIsOpen(false), []);
  const handleConfirm = useCallback(() => {
    onConfirm();
    handleClose();
  }, [handleClose, onConfirm]);

  const buttons = useMemo(() => {
    return (
      <>
        <Button variant={variant} onClick={handleClose} color="secondary">
          {strings.cancelText}
        </Button>
        <Button variant={variant} onClick={handleConfirm} color={color}>
          {strings.confirmText}
        </Button>
      </>
    );
  }, [handleClose, handleConfirm, strings, variant, color]);
  return (
    <>
      <Box display="flex">
        <Box>
          <Button variant={variant} onClick={handleClickOpen} color={color}>
            {strings.buttonText}
          </Button>
        </Box>
        <Box ml={2}>
          <Button variant={variant} onClick={handleClickBack} color="secondary">
            {strings.backText}
          </Button>
        </Box>
      </Box>
      <ModalDialog
        buttons={buttons}
        isOpen={isOpen}
        onClose={handleClose}
        title={strings.title}
        text={strings.text}
      />
    </>
  );
};
